import { DateTime } from "luxon"

export const getTimeAgo = (isoDateTime) => {
  const dt = DateTime.fromISO(isoDateTime)
  return `${dt.toRelative()} at ${dt.hour}:${
    dt.second < 10 ? "0" + dt.second : dt.second
  }`
}
